import React, { useEffect, useState, useContext } from "react";
import { Address, Contact, CopyRights, Awards } from "./Components";
import { UserContext } from "@/context/user";
import { Client } from "@/types/userManagement";
import { apiV2 } from "@/api/axiosConfig";
import WhiteLogo from "../WhiteLogo";


function Footer() {
  const userContext = useContext(UserContext)!;

  const [footerStyle, setFooterStyle] = useState<string>(
    "linear-gradient(to right, #2D166F 50%, #007584)" 
  );
  const previewActiveRef = React.useRef(false);

  const toPlatformStyle = (colours?: Client["platformColours"]) => {
    if (!colours) return "";
    if (colours.mode === "gradient" && colours.primary && colours.secondary) {
      const center = Math.max(0, Math.min(100, colours.gradientCenter ?? 75));
      const blend = Math.max(0, Math.min(100, colours.gradientBlend ?? 50));
      const start = Math.max(0, Math.min(100, center - blend / 2));
      const end = Math.max(0, Math.min(100, center + blend / 2));
      return `linear-gradient(to right, ${colours.primary} 0%, ${colours.primary} ${start}%, ${colours.secondary} ${end}%, ${colours.secondary} 100%)`;
    }
    if (colours.mode === "single" && colours.colour) {
      return colours.colour;
    }
    return "";
  };

  useEffect(() => {
    const fetchColours = async () => {
      if (!userContext.metadata.clientID) return;

      try {
        const res = await apiV2.get<Client>(`clients/${userContext.metadata.clientID}`);
        const colours = res.data.platformColours;

        if (previewActiveRef.current) {
          return;
        }
        const style = toPlatformStyle(colours);
        if (style) {
          setFooterStyle(style);
        }
      } catch (err) {
        console.error("Failed to load platform colours", err);
      }
    };

    fetchColours();
  }, [userContext.metadata.clientID]);

  useEffect(() => {
    const handlePreview = (evt: Event) => {
      const detail = (evt as CustomEvent<Client["platformColours"]>).detail;
      const style = toPlatformStyle(detail);
      if (!style) return;
      previewActiveRef.current = true;
      setFooterStyle(style);
    };

    window.addEventListener("platform-colours-preview", handlePreview);
    return () =>
      window.removeEventListener("platform-colours-preview", handlePreview);
  }, []);

  return (
    <footer
      className="grid grid-cols-[auto_auto_auto_1fr] gap-4 p-4 text-sm h-400"
      style={{ background: footerStyle }}
    >
      <div className="flex flex-col items-center justify-center">
        <div>
          <WhiteLogo />
        </div>
        <CopyRights />
      </div>
      <div>
        <Address />
      </div>
      <div>
        <Contact />
      </div>
    </footer>
  );
}

export default Footer;
